import React from 'react';
import '../../styles/jisbutton.css';
import DynamicIcon from '../dynamicicon';
import * as Constants from '../../constants';

function JisTabButton({
  code,
  onClick,
  title,
  isActive=false,
  loading = false,
  icon = null,
  iconPosition = 'left',
  isRoleBased=true,
  data=null,

}) {
   const item=Constants.PageDetails(data,'tab',code);
  const _loading= loading || (isRoleBased && data==null);

   // 👉 Don't render the button if item not found and data is not null
  if (!_loading && isRoleBased && data !== null && !item) return null;
  return (
   !_loading?
    <div className={`tabline ${isActive?'active':''}`} onClick={onClick}>{data?<>
    { iconPosition === 'left' && (
            <span className="button-icon left"><DynamicIcon iname={item?.icon || icon} /></span>
          )}
    <span>{item?.title} </span>
{ iconPosition === 'right' && (
            <span className="button-icon right"><DynamicIcon iname={item?.icon || icon} /></span>
          )}
    </>
    :<span>{title}</span>}</div>:<div style={{background:'var(--primary)', padding:16}}><div className="spinner"></div></div>
  );
}

export default JisTabButton;
